import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

// Initialize Firebase
import './utils/firebase.js';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
